/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePublicApiKeyRequest
 */
export interface CreatePublicApiKeyRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePublicApiKeyRequest
     */
    clientName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePublicApiKeyRequest
     */
    scopes: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof CreatePublicApiKeyRequest
     */
    expiresAt?: Date | null;
}

/**
 * Check if a given object implements the CreatePublicApiKeyRequest interface.
 */
export function instanceOfCreatePublicApiKeyRequest(value: object): value is CreatePublicApiKeyRequest {
    if (!('clientName' in value) || value['clientName'] === undefined) return false;
    if (!('scopes' in value) || value['scopes'] === undefined) return false;
    return true;
}

export function CreatePublicApiKeyRequestFromJSON(json: any): CreatePublicApiKeyRequest {
    return CreatePublicApiKeyRequestFromJSONTyped(json, false);
}

export function CreatePublicApiKeyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePublicApiKeyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientName': json['clientName'],
        'scopes': json['scopes'],
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
    };
}

export function CreatePublicApiKeyRequestToJSON(json: any): CreatePublicApiKeyRequest {
    return CreatePublicApiKeyRequestToJSONTyped(json, false);
}

export function CreatePublicApiKeyRequestToJSONTyped(value?: CreatePublicApiKeyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientName': value['clientName'],
        'scopes': value['scopes'],
        'expiresAt': value['expiresAt'] == null ? value['expiresAt'] : value['expiresAt'].toISOString(),
    };
}

